export default __webpack_public_path__ + "static/media/photo--sm--misc-8.5c6e474e.jpg";